import { IconButton } from "@mui/material";
import EditIcon from "assets/icons/EditIcon";
import TrashIcon from "assets/icons/TrashIcon";

export interface PlansProps {
  plans: Plan[];
  onEdit: (item: Plan) => void;
  onDelete: (item: Plan) => void;
}
export default function Plans({ plans, onDelete, onEdit }: PlansProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {plans.map((plan, index) => {
        return (
          <div
            key={index}
            style={{
              border: "1px solid #BBD0ED",
              borderRight: "3px solid #BBD0ED",
              background:
                "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(216,232,255,1) 100%)",
              borderRadius: 4,
              padding: 9,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", gap: 10 }}>
              <span style={{ fontSize: 16, color: "#3D3D3D" }}>{plan.title}</span>
              <span style={{ fontSize: 14, color: "#8F8F8F" }}>{plan?.currency?.label}</span>
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <IconButton onClick={() => onEdit(plan)}>
                <EditIcon />
              </IconButton>
              <IconButton onClick={() => onDelete(plan)}>
                <TrashIcon color="#CB0B0B" />
              </IconButton>
            </div>
          </div>
        );
      })}
    </div>
  );
}
